<template>
  <section class="product">
    <div class="title-holder">
      <ol class="crumb-path">
        <li>
          <router-link
            class="link"
            :to="{
              name: 'printStore'
            }"
            v-if="!hideRijnjaContent"
          >
            <span>Signing</span>
            <!--   <span v-else>{{ printStoreTitle }}</span>
           -->
            <inline-svg
              src="/images/icons/chevron-right-solid.svg"
              class="crumb-path-divider"
            ></inline-svg
          ></router-link>
        </li>
        <li>
          <router-link
            class="link"
            :to="{
              name: 'printStoreCategory',
              params: { categoryId: this.$route.params.categoryId }
            }"
          >
            {{ categoryName }}
          </router-link>
          <inline-svg
            src="/images/icons/chevron-right-solid.svg"
            class="crumb-path-divider"
          ></inline-svg>
        </li>
        <li>
          <router-link
            class="link"
            :to="{
              name: 'printStoreCollection',
              params: {
                categoryId: this.$route.params.categoryId,
                collectionId: this.$route.params.collectionId
              }
            }"
          >
            {{ collectionName }}
          </router-link>
          <inline-svg
            src="/images/icons/chevron-right-solid.svg"
            class="crumb-path-divider"
          ></inline-svg>
        </li>
        <li>
          <h1 class="h1-md">{{ myProduct.name }}</h1>
        </li>
      </ol>
      <back-button class="back-button"></back-button>

      <h1 class="mobile">{{ myProduct.name }}</h1>
    </div>
    <section class="image-container">
      <bouncing-spinner
        v-if="imgLoading"
        class="image-loader"
      ></bouncing-spinner>
      <img
        :class="{ border: displaySpecs.border, loading: imgLoading }"
        :src="
          productImage(
            myProduct,
            myProduct.productType.printSpecification,
            466,
            color
          )
        "
      />
      <button
        @click="publish"
        v-if="myProduct.isCustomizable && showSaveCustomFiles"
        class="pill-button secondary publish-button"
      >
        opslaan en publiceren
      </button>

      <button
        v-if="myProduct.sourceProductId"
        class="pill-button secondary remove-saved-custom warning-grey"
        @click="removeCustomProduct"
      >
        Ontwerp verwijderen
      </button>
    </section>
    <section class="info">
      <h1 class="wide">{{ myProduct.name }}</h1>
      <div class="designer spec" v-if="myProduct.designer">
        <span class="title">Ontwerp</span>{{ myProduct.designer }}
      </div>
      <div class="designer spec" v-if="myProduct.articleNumber">
        <span class="title">Artikelnummer</span>{{ myProduct.articleNumber }}
      </div>
      <p class="description spec" v-html="myProduct.description"></p>
      <p v-for="(value, name, index) in extraInfo" :key="index" class="spec">
        <span class="title">{{ name }}</span
        >{{ value }}
      </p>
      <product-specs
        class="product-specs"
        :product="myProduct"
        :current-specs="currentSpecsFromQuery"
        :custom-specs="customSpecs"
        :img-loading="imgLoading"
        @set-color="setColor"
        @set-custom-field="setCustomField"
      ></product-specs>
    </section>
    <related-products
      v-if="relatedProducts.length > 1"
      :related-products="relatedProducts"
      :current-product="productId"
    ></related-products>
  </section>
</template>
<script>
import PrintStoreMixin from '../PrintStoreMixin'
import {
  generateFile,
  getCustomTemplate,
  getProduct
} from '@/features/printstore/PrintStoreApi'
import ProductSpecs from './ProductSpecs.vue'
import BackButton from './BackButton.vue'
import RelatedProducts from './RelatedProducts.vue'
import cloneDeep from 'lodash-es/cloneDeep'
import CustomProductDialog from '@/features/printstore/children/CustomProductDialog.vue'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  components: { ProductSpecs, BackButton, RelatedProducts },
  mixins: [PrintStoreMixin],
  props: ['productId', 'product', 'categoryId'],
  head() {
    return {
      title:
        this.myProduct.name +
        ' - Signing | Koninklijke Rijnja - Prints voor professionals',
      meta: [
        {
          name: 'description',
          content: this.myProduct.description
        },
        {
          property: 'og:description',
          content: this.myProduct.description
        },
        {
          property: 'og:title',
          content:
            this.myProduct.name +
            ' - Signing | Koninklijke Rijnja - Prints voor professionals'
        },
        {
          property: 'og:image',
          content:
            'https://www.rijnja.nl' +
            this.productImage(
              this.myProduct,
              this.myProduct.productType.printSpecification,
              466,
              this.color
            )
        },
        {
          property: 'og:url',
          content: this.$route.path
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Signing',
                item: 'https://www.rijnja.nl/printstore'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: this.categoryName,
                item:
                  'https://www.rijnja.nl/printstore/category/' +
                  this.$route.params.categoryId
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: this.collectionName,
                item:
                  'printstore/category/' +
                  this.$route.params.categoryId +
                  '/collection' +
                  this.$route.params.collectionId
              },
              {
                '@type': 'ListItem',
                position: 4,
                name: this.myProduct.name
              }
            ]
          })
        }
      ]
    }
  },
  data() {
    return {
      myProduct: {
        productType: {
          printSpecification: {}
        },
        previews: []
      },
      extraInfo: {},
      relatedProducts: [],
      color: '',
      customSpecs: {
        exportTypes: [],
        options: [],
        id: '',
        documentId: undefined,
        fieldData: {}
      },
      imgRequestId: 0,
      imgPendingCount: 0,
      collectionName: undefined
    }
  },
  async mounted() {
    this.myProduct = await getProduct(this.productId)

    if (this.myProduct.isCustomizable) {
      const defaultSize = this.myProduct.productType.printSpecification.products
        .default

      getCustomTemplate(this.myProduct.customVariants[defaultSize]).then(
        (response) => {
          this.customSpecs.exportTypes = response.exportbuttons
          this.customSpecs.options = response.tabs[0].fields
          this.customSpecs.productId = response.id

          if (this.customFields) {
            this.customSpecs.fieldData = cloneDeep(this.customFields)
            this.setCustomImage(this.customSpecs.fieldData)
          } else {
            this.customSpecs.options.forEach((option) => {
              this.customSpecs.fieldData[option.id] = option.defaultvalue
                ? option.defaultvalue
                : ''
            })
            //   this.setCustomImage()
          }
        }
      )
    }

    this.collectionName = this.myProduct.collections.find(
      (collection) => collection.id === this.$route.params.collectionId
    ).name

    this.printStoreStore.setCurrentProductName(this.myProduct.name)

    if (!this.printStoreStore.currentCollectionName) {
      this.printStoreStore.setCurrentCollectionName(
        this.myProduct.collections[0].name
      )
    }

    if (
      this.currentSpecsFromQuery &&
      this.myProduct.hasVariants &&
      this.myProduct.productType?.printSpecification?.colors?.values
    ) {
      const colors = this.myProduct.productType.printSpecification.colors.values

      let color = Object.keys(colors).find(
        (key) =>
          colors[key].name ===
          this.currentSpecsFromQuery[
            this.myProduct.productType.printSpecification.colors.title
          ]
      )

      this.setColor(color)
    }

    this.extraInfo = this.myProduct.productType.printSpecification.info || {}
    this.relatedProducts = this.myProduct.relatedProducts

    window.scrollTo({ top: 0 })
  },
  beforeDestroy() {
    this.printStoreStore.setCurrentProductName('')
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    imgLoading() {
      return this.imgPendingCount > 0
    },
    displaySpecs() {
      if (this.myProduct.displaySpecification) {
        return this.myProduct.displaySpecification
      } else {
        return {}
      }
    },
    // collectionName () {
    //   return this.myProduct?.collections.find(collection => collection.id === this.$route.params.collectionId).name
    // },
    categoryName() {
      if (this.$route.params.categoryId === 'shared') {
        return 'Aanbevolen'
      }
      const category = this.printStoreStore.getCategory(
        this.$route.params.categoryId
      )
      return category ? category.name : ''
    },
    currentSpecsFromQuery() {
      if (this.$route.query.currentSpecs) {
        return JSON.parse(this.$route.query.currentSpecs)
      } else {
        return undefined
      }
    },
    customFields() {
      if (this.$route.query.customFields) {
        return JSON.parse(this.$route.query.customFields)
      } else {
        return undefined
      }
    }
  },
  methods: {
    setColor(clr) {
      this.color = clr
    },
    setCustomField(val) {
      val[0].forEach((id) => {
        this.customSpecs.fieldData[id] = val[1]
      })

      this.setCustomImage(this.customSpecs.fieldData)
    },
    setCustomImage(fieldData) {
      // Elke aanvraag krijgt een oplopend ID; alleen het antwoord van de
      // laatste aanvraag mag de preview bijwerken. De teller houdt bij hoeveel
      // aanvragen er nog lopen, zodat de spinner pas verdwijnt als ze allemaal
      // klaar zijn.
      const requestId = ++this.imgRequestId
      this.imgPendingCount++

      const imageExport = this.customSpecs.exportTypes.find(
        (exportType) => exportType.isimage
      )
      const imgID = imageExport ? imageExport.id : 16

      generateFile(
        this.customSpecs.productId,
        fieldData,
        this.customSpecs.documentId,
        imgID
      )
        .then((resp) => {
          if (requestId !== this.imgRequestId) {
            // Verouderd antwoord: een nieuwere aanvraag is al gestart.
            return
          }

          this.customSpecs.documentId = resp.documentid
          const imgUrl = `https://rijnja.xpressionmanager.nl${resp.href}`

          this.myProduct.customImage = true
          this.myProduct.previewImage = imgUrl
        })
        .finally(() => {
          this.imgPendingCount--
        })
    },
    setCustomId(id) {
      if (this.customSpecs.productId != id) {
        this.customSpecs.productId = id
        this.customSpecs.documentId = ''
      }
    },
    async publish() {
      this.$modal.show(
        CustomProductDialog,
        {
          customProductSpecs: {
            sourceProductId: this.myProduct.id,
            designer: this.rootStore.user.name,
            templateId: this.customSpecs.productId,
            documentId: this.customSpecs.documentId,
            fieldData: this.customSpecs.fieldData,
            printStoreId: this.rootStore.theme.printStore.id
          }
        },
        {
          width: 400
        }
      )
    },
    removeCustomProduct() {
      this.deleteProduct(this.myProduct).then(() =>
        this.$router.push({
          name: 'printStoreCollection',
          params: {
            categoryId: this.$route.params.categoryId,
            collectionId: this.$route.params.collectionId
          }
        })
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.product {
  display: flex;
  flex-direction: column;
  padding: 0px 20px 60px;
  position: relative;
  align-content: flex-start;
}

.title-holder {
  padding-top: 20px;
  display: flex;
  align-items: baseline;
}

.image-container {
  padding-bottom: 20px;
  text-align: center;

  img {
    justify-self: center; // forces Safari to resize on image change - https://stackoverflow.com/a/61196907/26496
    align-self: center; // forces Safari to resize on image change - https://stackoverflow.com/a/61196907/26496
    max-width: 100%;
    max-height: 466px;
    width: auto;
    height: auto;
    //border: 1px solid #efefef;
    transition: opacity 0.5s;

    &.loading {
      opacity: 30%;
    }
  }

  .border {
    border: 1px solid #e3e3e3;
  }

  .publish-button,
  .remove-saved-custom {
    display: block;
    margin: 10px auto;
  }
}

h1 {
  font-size: 30px;
  color: var(--sub-color);
  //margin-bottom: 20px;
  // line-height: 34px;

  font-size: 19px;
  font-weight: 500;
}

h1.mobile {
  padding-left: 10px;
}

h1.wide {
  display: none;
}

.title {
  font-weight: 500;
  padding-right: 5px;
}

.description {
  white-space: pre-line;
  line-height: normal;
}

.product-specs {
  margin-top: 5px;
}

.spec {
  // margin-bottom: 10px;
  padding-bottom: 10px;
  line-height: normal;
}

.crumb-path {
  display: none;
  list-style-type: none;

  .h1-md {
    display: none;
  }
}

.remove-custom {
  text-align: center;
  padding: 10px 0;
}

@media only screen and (min-width: 620px) {
  .title-holder {
    padding-top: 12px;
  }
}

@media only screen and (min-width: 940px) {
  .back-button {
    display: none;
  }

  .title-holder {
    flex-direction: row;
    padding-top: 0;
    margin-top: 11px;
    flex-wrap: wrap;
    padding-bottom: 14px;
  }

  h1.mobile {
    display: none;
  }

  h1.wide {
    display: block;
    word-break: break-word;
    line-height: 30px;
    font-size: 30px;
  }

  .crumb-path {
    display: flex;
    flex-wrap: wrap;
    color: var(--sub-color);
    font-weight: 400;
    line-height: 14px;
    padding-bottom: 6px;
    align-items: baseline;
    line-height: 19px;

    h1.h1-md {
      font-size: 30px;
      color: var(--sub-color);
      display: block;
      font-size: 19px;
      font-weight: 500;
      margin: 0;
    }

    .link {
      color: var(--sub-color);
      text-decoration: none;
      display: inline-block;
    }

    .md {
      display: inline-block;
    }
  }

  .divider {
    height: 10px;
    margin: 0 9px 0 6px;

    g {
      fill: var(--sub-color);
    }
  }
}

@media only screen and (min-width: 1280px) {
  .product {
    padding: 0px 0px 60px 12px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .title-holder {
    flex: 1 0 100%;
    padding-top: 14px;
    padding-bottom: 20px;
    margin-top: 0;
  }

  h1.mobile {
    display: none;
  }

  h1.wide {
    //    display: none;
  }

  .image-container {
    flex-shrink: 0;
    width: 466px;
    padding-bottom: 0;
    position: relative;

    .image-loader {
      position: absolute;
      left: calc(50% - 30px);
      z-index: 10;
      padding-top: 75px;
    }
  }

  .info {
    padding-left: 20px;
    flex-grow: 1;
    flex-basis: 268px;
    display: flex;
    flex-direction: column;
  }

  .description {
    flex-grow: 1;
  }

  .crumb-path {
    h1.h1-md {
      font-size: 0.875rem;
    }
  }
}
</style>
